export default {
    path: '/modules/roles',
    name: 'modules-roles',
    component: () => import('@/modules/roles/pages/index.vue'),
    children: [
        {
            path: 'list',
            component: () => import('@/modules/roles/pages/list.vue'),
            meta: {
                pageTitle: '角色权限列表',
            }
        },
        {
            path: 'edit/:role_id?',
            component: () => import('@/modules/roles/pages/edit.vue'),
            meta: {
                pageTitle: '添加/修改角色权限',
                parent: '/modules/roles/list',
            }
        }
    ],

};
